import React from "react"

import {
  TerminalAddButtonContainer,
  TerminalAddButtonCircle,
  TerminalBranchLabel
} from "./TerminalAddButton.styled"

type Props = {
  onClick: () => void
  /** Horizontal offset in % from the node's left edge (e.g. "25%" for condition "Yes" branch). */
  left?: string
  /** Optional branch label shown above the "+" (e.g. Yes/No on condition branches). */
  branchLabel?: "yes" | "no"
  /** Highlight this "+" as an active drop target while a node is dragged over it. */
  highlighted?: boolean
}

const TerminalAddButton = ({
  onClick,
  left = "50%",
  branchLabel,
  highlighted = false
}: Props) => (
  <TerminalAddButtonContainer style={{ left }}>
    {branchLabel && (
      <TerminalBranchLabel $variant={branchLabel}>
        {branchLabel === "yes" ? "Yes" : "No"}
      </TerminalBranchLabel>
    )}
    <TerminalAddButtonCircle
      type="button"
      aria-label="Add node"
      className="nodrag nopan"
      $highlighted={highlighted}
      onClick={(e) => {
        e.stopPropagation()
        onClick()
      }}
    >
      +
    </TerminalAddButtonCircle>
  </TerminalAddButtonContainer>
)

export default TerminalAddButton
